import axios from "axios";
import qs from "qs";
const initialState = {
    helpArticle: {
        title: "",
        abstract: "",
        body: "",
        json: {},
        html: "",
        category: "kolkin",
    },
    helpCategories: [],
    helpArticles: [],
    helpArticleCount: 0,
    helpCategoryArticles: {}
};
export const state = { ...initialState };
export const actions = {
    async loadHelpArticle(context,id){
        return axios.get('/api/help/blog/article',{params:{id:id}}).then(function(response){
            context.commit('helpArticleSet',response.data);
        });
    },
    resetArticle(context){
        context.commit('articleClear');
    },
    async loadHelpCategories(context){
        return axios.get("/api/help/blog/category").then(function(response){
            context.commit("setHelpCategories",response.data)
        })
    },
    async loadHelpArticles(context,params){
        return axios.get("/api/help/blog/articles",{params: params,
        paramsSerializer(params){
            var result = qs.stringify(params,{arrayFormat: "brackets"});
            return result
            }
        }).then(function(response){
        	console.log(response)
            context.commit("setHelpArticles",response.data.articles);
            context.commit("setHelpArticleCount",response.data.count);
        })
    },
    async loadMoreHelpArticles(context,params){
        return axios.get("/api/help/blog/articles",{params: params,
        paramsSerializer(params){
            var result = qs.stringify(params,{arrayFormat: "brackets"});
            return result
            }
        }).then(function(response){
            context.commit("appendHelpArticles",response.data.articles);
            context.commit("setHelpArticleCount",response.data.count);

        })
    },

}

export const mutations = {

    articleClear(state){
        state.helpArticle =  {
            title: "",
            abstract: "",
            body: "",
            json: {},
            html: "",
            category: "kolkin",
            color: "primary",
        };
    },

    helpArticleSet(state, article){
        state.helpArticle = article;
        if(article.json){
            state.helpArticle.json = JSON.parse(article.json)
        }

    },

    articleUpdate(state, articleUpdate) {

        state.helpArticle.title = articleUpdate.title;
        state.helpArticle.abstract = articleUpdate.abstract;
        state.helpArticle.body = articleUpdate.body;
        state.helpArticle.json = articleUpdate.json;
        state.helpArticle.html = articleUpdate.html;


    },

    setHelpCategories(state, data){
        state.helpCategories = data;
    },

    setHelpArticles(state, data){
        state.helpArticles = data;
		state.helpCategoryArticles = {};
		for (var i = 0; i < data.length; i++){

			if(state.helpCategoryArticles[data[i].category]){
				state.helpCategoryArticles[data[i].category].push(data[i]);
			}else {
				state.helpCategoryArticles[data[i].category] = [data[i]];
			}
		}
    },

    setHelpArticleCount(state,data){
        state.helpArticleCount = data;
    },

    appendHelpArticles(state,data){
        state.helpArticles = state.helpArticles.concat(data);
    },

    setCategory(state,data){
        state.helpArticle.category = data;
    }

}

const getters = {
    helpArticle(state){
        return state.helpArticle;
    },

    helpArticleCount(state){
        return state.helpArticleCount;
    },

    helpArticles(state){
        return state.helpArticles;
    },

    helpCategories(state){
        return state.helpCategories
    },

    helpCategoryArticles(state){
		return state.helpCategoryArticles;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
  };
